'use strict';

var AppDispatcher = require('../dispatcher/AppDispatcher');
var RemixerConstants = require('../constants/RemixerConstants');

var WebAPI = require('../utils/WebAPI');

/** @module VimeoActionsCreator
 * @requires AppDispatcher
 * @requires RemixerConstants
 * @requires WebAPI
 */
var VimeoActionsCreator = {
	/**
	 * @method requestVimdoeAuthorizationUrl
	 */
	requestVimdoeAuthorizationUrl: function(returnToUrl) {
		AppDispatcher.dispatch({
			actionType: RemixerConstants.REQUEST_VIMEO_AUTHORIZATION_URL,
			returnTo: returnToUrl
		},
		WebAPI.getVimeoAuthorizationUrl, [returnToUrl]);
	}
};

module.exports = VimeoActionsCreator;
